export default __webpack_public_path__ + "static/UnitedGulf-01-bc9020241bf5c3cd858b6d65d7d50174.webp";